export default {
  styleOverrides: {
    root: {
      verticalAlign: 'middle',
    },
  },
};
